import { Company, ICompany } from '@shared/models/company';
import { IPerson, Person } from '@shared/models/person';

export type BoatOptionOwner = Pick<IPerson, 'id' | 'firstName' | 'lastName'>;
export type BoatOptionOwnerCompany = Pick<ICompany, 'id' | 'name'>;

export interface IBoatOption {
    id: number;
    name: string | null;
    licensePlate: string | null;
    manufacturer: string | null;
    type: string | null;
    length?: number | null;
    lengthOverall?: number | null;
    width?: number | null;
    depth?: number | null;
    owner: BoatOptionOwner | null;
    ownerCompany: BoatOptionOwnerCompany | null;
}

export class BoatOption {
    id: number;
    name: string | null;
    licensePlate: string | null;
    manufacturer: string | null;
    type: string | null;
    length: number | null;
    lengthOverall: number | null;
    width: number | null;
    depth: number | null;
    owner: Person | null;
    ownerCompany: Company | null;

    constructor(data: Partial<IBoatOption> = {}) {
        this.id = data.id ?? null;
        this.name = data.name ?? null;
        this.licensePlate = data.licensePlate ?? null;
        this.manufacturer = data.manufacturer ?? null;
        this.type = data.type ?? null;
        this.length = data.length ?? null;
        this.lengthOverall = data.lengthOverall ?? null;
        this.width = data.width ?? null;
        this.depth = data.depth ?? null;
        this.owner = data.owner ? new Person(data.owner as IPerson, true) : null;
        this.ownerCompany = data.ownerCompany ? new Company(data.ownerCompany as ICompany, true) : null;
    }

    toString(): string {
        return [this.licensePlate, this.name].filter(_ => !!_).join(', ');
    }
}
